import { render, staticRenderFns } from "./SynergismTabButton.vue?vue&type=template&id=1e3e3693&scoped=true&"
import script from "./SynergismTabButton.vue?vue&type=script&lang=js&"
export * from "./SynergismTabButton.vue?vue&type=script&lang=js&"
import style0 from "./SynergismTabButton.vue?vue&type=style&index=0&id=1e3e3693&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3e3693",
  null
  
)

export default component.exports